import React, { useContext } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import AssessmentSessionContext from '../../context/AssessmentSessionContext';

const SubmittedPage = () => {
  const { driveInfo } = useContext(AssessmentSessionContext);

  const attemptId = `ATT-${Math.random().toString(36).substr(2, 6).toUpperCase()}`;

  return (
    <div className="vh-100 d-flex justify-content-center align-items-center bg-light" style={{ backgroundImage: 'radial-gradient(#e1dfd5 1px, transparent 1px)', backgroundSize: '20px 20px' }}>
      <div className="card custom-card border-0 shadow-lg text-center p-5 rounded-4" style={{ maxWidth: '600px', width: '100%' }}>
        <FaCheckCircle className="text-success mx-auto mb-4" size={72} />
        <h2 className="fw-bold text-primary-custom mb-3">Assessment Submitted Successfully!</h2>
        <p className="text-muted fs-5 mb-5">Thank you for participating in the {driveInfo?.driveName || 'Recruitment'} Drive.</p>
        
        <div className="bg-light p-4 rounded-3 border mb-5 text-start">
          <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
            <span className="text-muted fw-semibold">Attempt ID</span>
            <span className="fw-bold mono-text">{attemptId}</span>
          </div>
          <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
            <span className="text-muted fw-semibold">Submission Time</span>
            <span className="fw-bold">{new Date().toLocaleString()}</span>
          </div>
          <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
            <span className="text-muted fw-semibold">Company Name</span>
            <span className="fw-bold">{driveInfo?.companyName || 'BLive'}</span>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted fw-semibold">HR Contact</span>
            <span className="fw-bold text-primary">{driveInfo?.hrEmail || 'hr@blive.co.in'}</span>
          </div>
        </div>

        <div className="alert alert-info border-0 bg-primary bg-opacity-10 text-primary-custom rounded-3">
          <strong>What's Next?</strong> The HR team will review your submission and get back to you via your registered email address within 7-10 business days. You may now safely close this tab.
        </div>
      </div>
    </div>
  );
};

export default SubmittedPage;
